/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_StatusInputs */

const en_vault_status = /** @type {(inputs: Vault_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const es_vault_status = /** @type {(inputs: Vault_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado`)
};

const fr_vault_status = /** @type {(inputs: Vault_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut`)
};

const de_vault_status = /** @type {(inputs: Vault_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const id_vault_status = /** @type {(inputs: Vault_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

/** @type {(inputs: Vault_StatusInputs) => LocalizedString} */
const ja_vault_status = en_vault_status;

/** @type {(inputs: Vault_StatusInputs) => LocalizedString} */
const zh_vault_status = en_vault_status;

/** @type {(inputs: Vault_StatusInputs) => LocalizedString} */
const ar_vault_status = en_vault_status;

/** @type {(inputs: Vault_StatusInputs) => LocalizedString} */
const it_vault_status = en_vault_status;

/** @type {(inputs: Vault_StatusInputs) => LocalizedString} */
const ru_vault_status = en_vault_status;

/** @type {(inputs: Vault_StatusInputs) => LocalizedString} */
const pt_vault_status = en_vault_status;

/** @type {(inputs: Vault_StatusInputs) => LocalizedString} */
const ko_vault_status = en_vault_status;

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Vault_StatusInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_status = /** @type {((inputs?: Vault_StatusInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_StatusInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_status(inputs)
	if (locale === "es") return es_vault_status(inputs)
	if (locale === "fr") return fr_vault_status(inputs)
	if (locale === "de") return de_vault_status(inputs)
	if (locale === "ja") return ja_vault_status(inputs)
	if (locale === "zh") return zh_vault_status(inputs)
	if (locale === "ar") return ar_vault_status(inputs)
	if (locale === "id") return id_vault_status(inputs)
	if (locale === "it") return it_vault_status(inputs)
	if (locale === "ru") return ru_vault_status(inputs)
	if (locale === "pt") return pt_vault_status(inputs)
	return ko_vault_status(inputs)
});